import {Injectable} from '@angular/core';
import {Preferences} from '@capacitor/preferences';

@Injectable({
	providedIn: 'root'
})
export class LocalDataService {

	constructor() {
	}

	async configure() {
		await Preferences.configure({group: 'atmosphere_app'});
	}

	async setItem(key, data) {
		if (key != null) {
			key = key.toLowerCase();
		}
		await Preferences.set({
			key,
			value: JSON.stringify(data)
		});
	}

	async getItem(key) {
		if (key != null) {
			key = key.toLowerCase();
		}
		const ret = await Preferences.get({key});
		return JSON.parse(ret.value);
	}

	async removeItem(key) {
		if (key != null) {
			key = key.toLowerCase();
		}
		await Preferences.remove({key});
	}

	cloneObject(object) {
		const clonedObject = Object.assign({}, object);
		return clonedObject;
	}

	cloneArray(array) {
		const clonedArray = [];
		array.forEach(val => clonedArray.push(Object.assign({}, val)));
		return clonedArray;
	}
}
